import { useNavigateBack } from '@iheartjane/menu';
import { Flex } from '@iheartjane/reefer';
import { normalizeUrl } from '@iheartjane/utils';

import { useKioskSpacing } from '../../../../hooks';
import { useCheckout } from '../../../../providers';
import { toAgreementScanPrompt } from '../../../../util';
import { CheckoutFlowButton } from '../../CustomerInfoFields/CustomerInfoFields';
import { Modal } from '../../Modal';
import { QRCodeCallout } from '../../QRCodeCallout/QRCodeCallout';
import { ButtonWrapper } from '../checkout.styles';
import { AgreementsModalHeader } from './AgreementsModalHeader';

import styles from './AgreementQRCodeScreen.module.css';

/**
 * Second page of the agreements step: the QR code for the agreement link the
 * shopper tapped, so they can read the terms on their own phone. Once every
 * required agreement is checked they can continue straight to checkout from
 * here; otherwise the only way out is back to the checkboxes.
 */
export const AgreementQRCodeScreen = () => {
  const { getKioskSpacing, isIpad } = useKioskSpacing();
  const {
    acceptAgreements,
    agreementLinkInView,
    requiredConsentsValid,
    setAgreementLinkInView,
    store,
  } = useCheckout();

  const goBack = useNavigateBack(`stores/${store.id}/menu`);

  const returnToAgreements = () => setAgreementLinkInView(null);

  return (
    <>
      <AgreementsModalHeader />

      <Modal.Content overflowY="auto" padding={false}>
        {agreementLinkInView && (
          <QRCodeCallout
            ariaLabel={`QR code for ${agreementLinkInView.label}`}
            size={320}
            text={toAgreementScanPrompt(agreementLinkInView)}
            textClassName={styles['scanPrompt']}
            textVariant="body-regular"
            type="agreement"
            url={normalizeUrl(agreementLinkInView.url)}
          />
        )}
      </Modal.Content>

      <Flex
        flexDirection="column"
        pb={getKioskSpacing(32, 40)}
        px={getKioskSpacing(32, 40)}
        shrink={false}
      >
        {requiredConsentsValid ? (
          <ButtonWrapper
            gap={getKioskSpacing(24, 16)}
            isIpad={true}
            marginTop={0}
          >
            <CheckoutFlowButton
              buttonLabel="Cancel"
              onClick={() => goBack()}
              size={isIpad ? 'small' : 'large'}
              variant="tertiary"
            />
            <CheckoutFlowButton
              ariaLabel="continue to enter your customer information"
              buttonLabel="Next"
              onClick={acceptAgreements}
              size={isIpad ? 'small' : 'large'}
            />
          </ButtonWrapper>
        ) : (
          <CheckoutFlowButton
            buttonLabel="Back"
            onClick={returnToAgreements}
            size={isIpad ? 'small' : 'large'}
            variant="tertiary"
          />
        )}
      </Flex>
    </>
  );
};
